window.DataStream = null;
import { Buffer } from 'buffer';
globalThis.Buffer = Buffer;
window.Buffer = Buffer;
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './styles/tailwind.css';
import '../node_modules/primereact/resources/themes/bootstrap4-light-blue/theme.css';

//import 'font-awesome-webpack-4';
import 'moment/locale/ar';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';
import 'moment/locale/en-gb';
import 'bz-core-controls/utils/reflect-metadata';

import history from 'bz-utilities/modules/networking/history/rr4';
import $ from 'jquery';
import Moment from 'moment';
import QueryString from 'query-string';
import Api from 'tm3-core/api';
import { cache } from 'tm3-core/cache';
import validate from 'validate.js';
import App from './app';
import '../packages/apps/caseflow/entryPoint';
import PluginGDS from 'gds/entry-point';
import React from 'react';

if (!Object.values) {
  import('object.values').then((values) => values.shim());
}
window.React = React;
import Config from 'bz-stores/lib/config';
window.Config = Config;

const pathRgx = /\/zoom|\/pronto|\/recover\//;

Api.get('/api/loginMode')
  .then(({ body }) => {
    const { app } = cache;
    app.load(body.plugins);
    app.loginMode = body.result || '/login';
    app.prefix = body.prefix;
    app.isEnterpriseClient = body.isEnterpriseClient;
    PluginGDS();
    const allowedPaths = [
      '/login',
      '/no-user',
      '/wrong-address',
      '/verify',
      '/recover',
      '/auto-login',
      '/no-user'
    ];
    if (
      !body.isAuthenticated &&
      !allowedPaths.some((x) => window.location.pathname.startsWith(x))
    ) {
      const url = `${body.result}?redirect=${window.location.origin}`;
      if (app.loginMode === '/login') history.replace(url);
      else window.location = url;
    }

    if (!pathRgx.test(window.location.pathname)) {
      if (['/login', '/'].includes(window.location.pathname)) {
        if (body.result === '/') {
          if (pathRgx.test(window.location.search)) {
            const { redirectTo } = QueryString.parse(window.location.search);
            if (!!redirectTo) {
              history.push(redirectTo);
              window.redirectTo = redirectTo;
            } else {
              history.replace('/');
            }
          } else {
            history.replace('/');
          }
        }
      }
    }
  })
  .catch((ex) => {
    if (ex.status === 404) {
      history.replace('/wrong-address');
    }
  });

// This fix adds local timezone into the serialised JSON that gets posted everywhere,
// which can then be sanitized by the API
/* eslint-disable no-extend-native */
Date.prototype.toJSON = function () {
  // Don't Timezone the report parameters
  if (window.location.pathname === '/reports/bespoke/view') {
    return this.toISOString();
  }

  return Moment(this).format('YYYY-MM-DDTHH:mm:ss');
};
/* eslint-enable no-extend-native */

const dateValidator = {
  parse: function (value, options) {
    let date = Moment.utc(value);

    if (options.dateOnly) return +date.startOf('day');
    return +date;
  },
  format: function (value, options) {
    var format = options.dateOnly ? 'YYYY-MM-DD' : 'YYYY-MM-DDThh:mm:ss';
    return Moment.utc(value).format(format);
  }
};

validate.extend(validate.validators.datetime, dateValidator);
validate.extend(validate.validators.date, dateValidator);

let { localStorage } = window;

window.addEventListener('beforeunload', (e) => {
  window.Intercom?.('shutdown');
});

import './main.styl';
import './styles/bz-controls.styl';
import './styles/replace-pages.styl';
import './styles/typography.styl';
import './styles/responsive.styl';
import './styles/print.styl';
import './styles/util.styl';
import './styles/new-ux.styl';

if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

// shim from promises (looking at you IE10)
import 'native-promise-only';

if (!Promise.prototype.finally) {
  Promise.prototype.finally =
    Promise.prototype.finally ||
    {
      finally(fn) {
        const onFinally = (value) => Promise.resolve(fn()).then(() => value);
        return this.then(
          (result) => onFinally(result),
          (reason) => onFinally(Promise.reject(reason))
        );
      }
    }.finally;
}

import MobileDetect from 'mobile-detect';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

let el = null;
const boot = function (locale) {
  document.body.classList.add(`locale-${locale}`);
  localStorage.removeItem('returnUrl');
};
el = document.createElement('div');
el.id = 'tm2-app';
document.body.appendChild(el);
window.mobileDetection = new MobileDetect(window.navigator.userAgent);

const localeApply = function () {
  if (window.localStorage.locale) {
    Moment.locale([window.localStorage.locale, 'en-gb']);
    return applyCulture(window.localStorage.locale);
  } else {
    return Api.get('/api/locale')
      .then((res) => {
        const locale = res.body.result;
        window.localStorage.locale = locale;
        Moment.locale([locale, 'en-gb']);
        return applyCulture(locale);
      })
      .catch(async (err) => {
        if (
          err.status == '404' &&
          err.response.body.responseStatus.errorCode ===
            'The requested subdomain is not a valid TM3 subdomain.'
        ) {
          const el = document.createElement('div');
          el.id = 'tm3-404';
          document.body.appendChild(el);
          let NotFoundWarning = (await import('./controls/not-found-warning')).default;
          return createRoot(el).render(<NotFoundWarning />);
        }
      });
  }
};

const applyCulture = (locale) => {
  return $.getScript(`/culture/kendo.culture.${locale}.min.js`).then(() => {
    window.kendo.culture(locale);
    return boot(locale);
  });
};

const sharedTabLogout = (e) => {
  if (e.key === 'tm3-logout') {
    return history.push('/login');
  }
};

window.addEventListener('storage', sharedTabLogout, false);

if (process.env.ReactVersion?.toString() === '18') createRoot(el).render(<App />);
else ReactDOM.render(<App />, el);

if (window.location.pathname !== '/zoom') {
  localeApply();
}
